export const TRANSLATIONS = {
  // TODO: delete when it will be taken from events service - task 882
  EVENT_TYPE: {
    EB_EDUCATION: 'Vzdělávání',
    EB_EDUCATION_DESC: 'Vzdělávací aktivity a školení',

    EB_INDIRECT_WORK: 'Nepřímá práce',
    EB_INDIRECT_WORK_DESC: 'Práce, která nepřímo souvisí s hlavními úkoly',

    EB_AVAILABILITY: 'Dostupnost',
    EB_AVAILABILITY_DESC: 'Časy, kdy je pracovník k dispozici',

    EB_HOME_OFFICE: 'Práce z domova',
    EB_HOME_OFFICE_DESC: 'Práce vykonávaná z domova',

    EB_STANDBY: 'Pohotovost',
    EB_STANDBY_DESC: 'Čekání na případné nasazení',

    EB_SICKNESS: 'Nemoc',
    EB_SICKNESS_DESC: 'Nemocenská nebo pracovní neschopnost',

    EB_VACATION: 'Dovolená',
    EB_VACATION_DESC: 'Plánovaná dovolená',

    EB_PAID_LEAVE: 'Placené volno',
    EB_PAID_LEAVE_DESC: 'Nepracovní dny s náhradou mzdy',

    EB_UNPAID_LEAVE: 'Neplacené volno',
    EB_UNPAID_LEAVE_DESC: 'Nepracovní dny bez náhrady mzdy',

    EB_ASSISTANCE: 'Asistence',
    EB_ASSISTANCE_DESC: 'Poskytování asistence klientům',

    EB_SR_EVENT: 'SR událost',
    EB_SR_EVENT_DESC: 'Speciální SR událost',

    EB_SR_GROUP_EVENT: 'SR skupinová událost',
    EB_SR_GROUP_EVENT_DESC: 'Skupinová SR událost',

    EB_DAYCARE: 'Denní péče',
    EB_DAYCARE_DESC: 'Denní péče a programy',

    EB_TRANSIT: 'Přechod',
    EB_TRANSIT_DESC: 'Přechodné nebo transportní aktivity',

    EB_BASIC_SOCIAL_COUNSELING: 'Základní sociální poradenství',
    EB_BASIC_SOCIAL_COUNSELING_DESC: 'Poradenství a podpora klientům',

    EB_INTAKE: 'Přijímací proces',
    EB_INTAKE_DESC: 'Prvotní přijímání nových klientů',
  },
  FORMAT: {
    DATE: 'dd. MM. yyyy',
  },
  FORM: {
    VALIDATION: {
      REQUIRED: 'Pole je povinné',
    },
    LOADING_VALIDATION: 'Probíhá kontrola...',
  },
  TOAST: {
    SUCCESS: 'Úspěch',
    ERROR: 'Chyba',
  },
  WORK_POSITION_MODULE: {
    TITLE: 'Pracovní pozice',
    TABLE: {
      HEADERS: {
        DIVISION: 'Členění',
        NAME: 'Název pracovní pozice / aliasu',
        EXPORTABLE: 'Vykazatelné',
        ACTIONS: 'Akce',
      },
      NEW_TEMP_ALIAS_NAME: 'nový alias',
      ACTIONS_TOOLTIPS: {
        ADD: 'Vytvořit alias',
        DELETE: 'Smazat alias',
        DELETE_DISABLED: 'Nelze smazat, pracovní pozice musí obsahovat alespoň jeden alias',
      },
    },
    CRUD: {
      CREATE: {
        SUCCESS: 'Pozice byla vytvořena',
        ERROR: 'Nepodařilo se vytvořit pozici',
      },
      READ: {
        ERROR: 'Nepodařilo se načíst pracovní pozice',
      },
      UPDATE: {
        SUCCESS: 'Pozice byla aktualizována',
        ERROR: 'Nepodařilo se aktualizovat pozici',
      },
      DELETE: {
        SUCCESS: 'Pozice byla odstraněna',
        ERROR: 'Nepodařilo se odstranit pozici',
      },
    },
    DELETE_CONFIRM_DIALOG: {
      HEADER: "Potvrzení smazání aliasu '{{aliasName}}'",
      MESSAGE: "Přejete si smazat alias '{{aliasName}}'?",
      BUTTONS: {
        ACCEPT: {
          LABEL: 'Smazat',
        },
        REJECT: {
          LABEL: 'Zrušit',
        },
      },
    },
    TOOLBAR: {
      BUTTONS: {
        EXPAND: {
          LABEL: 'Rozbalit vše',
        },
        COLLAPSE: {
          LABEL: 'Zabalit vše',
        },
      },
      SEARCH: {
        PLACEHOLDER: 'Vyhledat pracovní pozici',
      },
    },
  },
  COMMON: {
    SEARCH_LOCATION: 'Vyhledat lokaci',
    NO_RESULTS_FOUND: 'Žádné výsledky nebyly nalezeny',
    CLOSE: 'Zavřít',
    SOCIAL_SERVICE_PERMISSIONS: 'Oprávnění pro službu',
    SELECT_SERVICE_AND_LOCATION: 'Vyberte službu a lokaci',
    CHOSEN_SERVICE_AND_LOCATION: 'Vybraná lokace byla úspěšně změněna',
    FILTER_WORKERS_ONLY: 'Pouze pracovníci',
    FILTER_ROLES: 'Vyfiltrovat podle role',
    SEARCH: 'Vyhledávání',
    ADD_USER: 'Přidat uživatele',
    USER_MANAGEMENT: 'Správa uživatelů',
    ROLE: 'Role',
    TOOLTIP_ADD_USER: 'Přidat nového uživatele',
    TOOLTIP_SEARCH: 'Vyhledávání uživatelů',
    TOOLTIP_ROLE: 'Vyberte roli pro filtrování',
    TOOLTIP_LOCATION: 'Vyberte lokaci pro filtrování',
    TOOLTIP_EDIT: 'Upravit uživatele',
    TOOLTIP_DELETE: 'Smazat uživatele',
    LOCATION: 'Lokace',
    ONLY_WORKERS: 'Pouze pracovníci',
    EDIT_USER: 'Upravit uživatele',
    DELETE_USER: 'Smazat uživatele',
    DESCRIPTION: 'Popis',
    ENTRY: 'Zápis',
    TOUR_LOCATION_SELECT_CONTENT:
      'Zde si můžeš zvolit, ve které alokaci právě pracuješ.<br><br>Alokace odpovídají jednotlivým lokacím (pobočkám) v dané sociální službě. Tato volba ovlivňuje, s jakými daty budeš v aplikaci pracovat.<br><br>Pokud máš přístup jen k jedné alokaci, vybrali jsme ji automaticky.',
    TOUR_LOCATION_SELECT_TITLE: 'Výběr aktivní alokace',
    TOUR_UNDERSTAND_BUTTON: 'Rozumím',
    EMPTY_DATA_MESSAGE: 'Žádná data k zobrazení',
    TOAST: {
      EVENT_SAVED_SUCCESS: 'Událost úspěšně uložena',
      EVENT_SAVE_ERROR: 'Chyba při ukládání události',
      EVENT_DELETED_SUCCESS: 'Událost úspěšně smazána',
      EVENT_DELETE_ERROR: 'Chyba při mazání události',
      NOT_AUTHORIZED: 'Nemáte oprávnění pro tuto sekci',
      SEND_ASSISTANCE_OVERVIEW_CANNOT_SEND:
        'Nelze odeslat: u klienta chybí kontaktní údaje nebo přehled není připraven.',
      SEND_ASSISTANCE_OVERVIEW_SUCCESS: 'Přehled asistencí byl úspěšně odeslán.',
    },
    CANCEL: 'Zrušit',
    DELETE: 'Smazat',
    OK: 'OK',
    SAVE: 'Uložit',
    PROCEED: 'Pokračovat',
    LOADING: 'Načítání...',
    YES: 'Ano',
    NO: 'Ne',
    SEND_ASSISTANCE_OVERVIEW: 'Zaslat přehled asistencí',
  },
  EVENT_EDITOR: {
    TITLE: 'Asistence: {{clientName}}',
    EDIT_MODE: 'Režim úprav',
    SAVE: 'ULOŽIT',
    SAVE_AND_CLOSE: 'ULOŽIT A ZAVŘÍT',
    VIEW: 'ZOBRAZIT',
    CREATE_TEMPLATE: 'VYTVOŘIT ŠABLONU',
    DUPLICATE: 'DUPLIKOVAT',
    DELETE: 'SMAZAT',
    CREATE: 'Vytvořit událost',
    UPDATE: 'Upravit událost',
    DEFAULT_EVENT_TYPE: 'Událost',
    DELETE_CONFIRMATION_HEADER: 'Smazat událost',
    DELETE_CONFIRMATION_MESSAGE: 'Opravdu chcete smazat tuto událost? Tato akce je nevratná.',
    SELECT_CLIENTS: 'Vyberte klienty',
    MAX_CLIENTS_SELECTED: 'Dosažen maximální počet klientů',
    ADD_MORE_CLIENTS: 'Přidat další klienty',
    UNKNOWN_CLIENT: 'Neznámý klient',
    NO_CLIENT_SELECTED: 'Žádný klient nevybrán',
    CLIENT_SELECTED: 'Klient vybrán',
    CLIENTS_SELECTED: 'Klienti vybráni',
    NO_CLIENTS_FOUND: 'Žádní klienti nenalezeni',
    CLIENT_SELECTION: 'Výběr klientů',
    CLIENT_SELECTION_SINGLE: 'Výběr klienta',
    ANONYMOUS_CLIENT: 'Anonymní klient',
    UNLIMITED: 'Neomezeně',
    CLIENT_SELECT: {
      SELECT_CLIENT: 'Vyberte klienta',
      MAX_SELECTION: 'Maximálně {{count}} klientů',
      SINGLE_SELECTION: 'Vyberte pouze jednoho klienta',
    },
    WORKER_SELECTION: 'Výběr pracovníků',
    WORKER_SELECTION_SINGLE: 'Výběr pracovníka',
    WORKER_AVAILABLE: 'Dostupný',
    WORKER_UNAVAILABLE: 'Nedostupný',
    PLANNED_DATES: 'Plánované datumy',
    REALIZED_DATES: 'Realizované datumy',
    SELECT_DATE_TIME: 'Vyberte datum a čas',
    WORKER_SELECT: {
      LABEL: 'Pracovník',
      ERROR_LOADING: 'Chyba při načítání pracovníků',
      SEARCH: 'Hledat',
      SELECT_AND_CLOSE: 'Zvolit a zavřít',
      SHOW_ALL_WORKERS: 'Zobrazit všechny pracovníky',
      TITLE: 'Dostupní pracovníci',
      TITLE_SINGLE: 'Dostupný pracovník',
      LOADING: 'Načítání pracovníků...',
      SELECT_WORKER: 'Vyberte pracovníka',
      SELECTED_COUNT: 'Vybráno: {{count}}',
      MAX_SELECTION: 'Maximálně {{count}} pracovníků',
      SINGLE_SELECTION: 'Vyberte pouze jednoho pracovníka',
    },
    BASIC: 'Základní',
    CLIENT: 'Klient',
    CLIENT_SEARCH_PLACEHOLDER: 'Zadejte jméno klienta...',
    SELECT_CLIENT: 'Vyberte klienta',
    SELECT_CLIENT_SINGLE: 'Vyberte klienta',
    SELECT_BUTTON_TEXT: 'Zvolit',
    CLOSE: 'Zavřít',
    ASSISTANT: 'Pracovník',
    TRANSIT_TIME: 'přejezd',
    MINUTES: 'min',
    PLANNED_FROM: 'Plánovaná od',
    PLANNED_TO: 'Plánovaná do',
    REALIZED_FROM: 'Reálně od',
    REALIZED_TO: 'Reálně do',
    RECURRENCE_SETTINGS: 'Nastavení opakování',
    TOOLTIPS: {
      SAVE: 'Uloží změny bez zavření.',
      SAVE_AND_CLOSE: 'Uloží změny a zavře editor.',
      VIEW: 'Zobrazí detail události.',
      CREATE_TEMPLATE: 'Vytvoří šablonu z této události.',
      DUPLICATE: 'Duplikuje tuto událost.',
      DELETE: 'Smaže tuto událost.',
    },
    PARAMETERS: 'Parametry',
    SLEEPOVER: 'Sleva',
    PREFERRED_ASSISTANT_GENDER: 'Preferované pohlaví pracovníka',
    MALE: 'Muž',
    FEMALE: 'Žena',
    STRONG_ASSISTANT_NEEDED: 'Vyžaduje silného',
    ADVANCED_ASSISTANT_NEEDED: 'Vyžaduje pokročilého',
    NOT_TO_BE_PRIMARILY_ASSIGNED: 'Primárně neobsazovat',
    LATE_ORDER: 'Pozdě objednaná',
    PAID_INTERNALLY: 'Placeno organizací',
    NON_CLIENT_WORK: 'Nepřímá práce',
    SENT_TO_CLIENT: 'Odesláno klientovi',
    SHOW_IN_EXCHANGE: 'Zobrazovat na burze',
    PERFORMANCE_TYPE: 'Typ výkonu',
    ASSISTANT_SELECTION_REQUIRES_DATES: 'Pro výběr pracovníka je potřeba nejdříve vybrat Plánovaná od a Plánovaná do',

    // Validation messages
    VALIDATION: {
      PLANNED_FROM_REQUIRED: 'Plánovaná od je povinná',
      PLANNED_TO_REQUIRED: 'Plánovaná do je povinná',
      PLANNED_TO_BEFORE_FROM: 'Plánovaná do musí být po Plánovaná od',
      REALIZED_TO_BEFORE_FROM: 'Reálně do musí být po Reálně od',
      TITLE_REQUIRED: 'Nadpis je povinný',
      PERFORMANCE_TYPE_REQUIRED: 'Typ výkonu je povinný',
      TAG_REQUIRED: 'Je nutné označit text alespoň jednou značkou',

      // Extended validation messages
      TYPE_OF_CONTACT_REQUIRED: 'Typ kontaktu je povinný',
      CLIENT_REQUIRED: 'Klient je povinný',
      WORKER_REQUIRED: 'Pracovník je povinný',
      TITLE_MIN_LENGTH: 'Název musí mít alespoň {minLength} znaků',
      TITLE_MAX_LENGTH: 'Název může mít maximálně {maxLength} znaků',
      CLIENT_MIN_ARRAY_LENGTH: 'Musíte vybrat alespoň {minArrayLength} klienta',
      MIN_CLIENTS_REQUIRED: 'Vyberte alespoň {{count}} klienta',
      MAX_CLIENTS_EXCEEDED: 'Překročen maximální počet {{count}} klientů',
      MIN_WORKERS_REQUIRED: 'Vyberte alespoň {{count}} pracovníka',
      MAX_WORKERS_EXCEEDED: 'Překročen maximální počet {{count}} pracovníků',
      UNAVAILABLE_WORKERS_WARNING: 'Někteří vybraní pracovníci nejsou dostupní v plánovaném čase',
      CLIENT_MAX_ARRAY_LENGTH: 'Můžete vybrat maximálně {maxCount} klientů',
      WORKER_MIN_ARRAY_LENGTH: 'Musíte vybrat alespoň {minArrayLength} pracovníka',
      WORKER_MAX_ARRAY_LENGTH: 'Můžete vybrat maximálně {maxCount} pracovníků',
      DATE_RANGE_INVALID: 'Plánované datum do musí být po plánovaném datu od',
      DATE_RANGE_OVERLAP: 'Datumy se překrývají s existujícím eventem',
      CUSTOM_INVALID: 'Hodnota neprošla vlastní validací',
      PATTERN_INVALID: 'Hodnota má neplatný formát',
      ENTER_NOTES_PLACEHOLDER: 'Zadejte zápis...',
      UNSUPPORTED_EVENT_TYPE: 'Nepodporovaný typ události',
    },

    // SR Event Editor
    SR_EVENT: {
      CONTENT: 'Obsah',
      CONTACT_TYPE: 'Typ kontaktu',
      SELECT_CONTACT_TYPE: 'Vyberte typ',
      TITLE: 'Nadpis',
      DESCRIPTION: 'Popis',
      NOTES: 'Zápis',
      INSERT_TAG: 'Vložit značku',
      NO_TAGS: 'Žádné značky',
      CLIENT_JOURNAL_ENTRIES: 'Zápisy klientů',
      DELETE_CLIENT_HEADER: 'Smazat klienta',
      DELETE_CLIENT_MESSAGE: 'Klient má vyplněný zápis. Opravdu chcete klienta odstranit?',
      DELETE_CLIENT_CANCEL: 'Zrušit',
      DELETE_CLIENT_CONFIRM: 'Smazat',
      VALIDATION: {
        NO_TAGS: 'Je nutné označit text alespoň jednou značkou',
      },
    },

    // Leave Event Editor
    LEAVE_EVENT: {
      CONTENT: 'Obsah',
      LEAVE_TYPE: 'Typ nepřítomnosti',
      SELECT_LEAVE_TYPE: 'Vyberte typ',
      DESCRIPTION: 'Popis',
      VALIDATION: {
        LEAVE_TYPE_REQUIRED: 'Typ nepřítomnosti je povinný',
        MAX_DURATION: 'Nepřítomnost nesmí být delší než 363 dní',
        WORKER_REQUIRED: 'Pracovník je povinný',
      },
    },

    CLIENT_RECORDS: 'Záznamy klientů',

    // Common actions
    UNSUPPORTED_EVENT_TYPE: 'Nepodporovaný typ události',
    UNSUPPORTED_EVENT_TYPE_MESSAGE:
      'Pro tento typ události není k dispozici specifický editor. Používají se pouze základní nastavení.',
  },
  PERFORMANCE_LIST: {
    TITLE: 'Seznam výkonů',
    CALENDAR_TOOLTIP: 'Přejít na kalendář výkonů',
    LIST_TOOLTIP: 'Zobrazit seznam výkonů',
    MENU_TOOLTIP: 'Otevřít menu',
    NOTIFY_ASSISTANTS:
      'Je třeba upozornit pracovníky na změny v potvrzených asistencích v příštím týdnu ({{nextWeekDates}}).',
    LOADING: 'Načítání...',
    TABLE: {
      globalFilterPlaceholder: 'Hledat ve výkonech...',
      HEADERS: {
        title: 'Název',
        plannedFrom: 'Datum výkonu',
        duration: 'Délka [h:m]',
        clients: 'Klienti',
        workers: 'Pracovníci',
        typeOfContact: 'Typ kontaktu',
        workType: 'Typ výkonu',
      },
    },
  },
  PERFORMANCE_LIST_TOOLBAR: {
    NEW_PERFORMANCE_TOOLTIP: 'Přidat nový výkon',
    SR_EVENT_TOOLTIP: 'Vytvořit individuální výkon',
    SR_GROUP_EVENT_TOOLTIP: 'Vytvořit skupinový výkon',
    IMPORT_TOOLTIP: 'Importovat výkony',
    EXPORT_TOOLTIP: 'Exportovat výkony',
    TEMPLATE_TOOLTIP: 'Zobrazit šablony výkonů',

    // Button text
    NEW_PERFORMANCE: 'Nový výkon',

    // Popover headers
    SELECT_PERFORMANCE_TYPE: 'Vyberte typ výkonu',
    QUICK_ACTIONS: 'Rychlé akce',

    // Event types
    SR_EVENT: 'SR Výkon',
    SR_GROUP_EVENT: 'SR Skupinový výkon',
    INDIVIDUAL_PERFORMANCE: 'Individuální výkon',
    GROUP_PERFORMANCE: 'Skupinový výkon',

    // Quick actions
    IMPORT_PERFORMANCES: 'Import výkonů',
    EXPORT_PERFORMANCES: 'Export výkonů',
    PERFORMANCE_TEMPLATES: 'Šablony výkonů',
  },
  PERFORMANCE_LIST_PAGE: {
    // Table configuration
    GLOBAL_FILTER_PLACEHOLDER: 'Hledat podle názvu, typu kontaktu, klientů nebo pracovníků...',

    // Column headers
    TITLE: 'Název',
    PERFORMANCE_DATE: 'Datum výkonu',
    HOURS_COUNT: 'Počet hodin',
    CLIENT_NAME: 'Jméno klienta/ů',
    WORKERS: 'Pracovník ',
    CONTACT_TYPE: 'Typ kontaktu',
    WORK_TYPE: 'Typ výkonu',
    ACTIONS: 'Akce',

    // Contact type options
    CONTACT_TYPE_EMAIL: 'E-mail',
    CONTACT_TYPE_PHONE: 'Telefon',
    CONTACT_TYPE_MEETING: 'Schůzka',
    CONTACT_TYPE_ASSISTANCE: 'Asistence',
    CONTACT_TYPE_OTHER: 'Ostatní',

    // Work type options
    WORK_TYPE_PP1: 'PP1',
    WORK_TYPE_PP2: 'PP2',
    WORK_TYPE_NP: 'NP',

    // Action tooltips
    EDIT_TOOLTIP: 'Upravit',

    // Status texts
    STATUS_PLANNED: 'Plánovaná',
    STATUS_IN_PROGRESS: 'Probíhá',
    STATUS_COMPLETED: 'Dokončená',
    STATUS_CANCELLED: 'Zrušená',
    STATUS_UNKNOWN: 'Neznámý',

    // Messages
    ERROR_LOADING_EVENTS: 'Chyba při načítání událostí',
    EVENT_UPDATED_SUCCESS: 'Event updated successfully, refreshing list...',
    FAILED_OPEN_MODAL: 'Failed to open edit modal:',
    FILTERS_CHANGED: 'Filters changed in performance list:',
    DATE_RANGE_CHANGED: 'Date range changed in performance list:',
    DEFAULT_DATE_RANGE_SET: 'Default date range set to today:',

    // Default values
    ANONYMOUS_CLIENT: 'anonym',
    UNKNOWN_WORKER: 'neznámý',
    NO_DATA: '-',

    // Debug messages (can be removed in production)
    RAW_EVENTS_RECEIVED: 'Raw events received:',
    CURRENT_DATE_RANGE: 'Current date range:',
    EVENTS_AFTER_FILTERING: 'Events after date filtering:',
    FINAL_EVENTS_COUNT: 'Final events count:',
    EVENT_REFRESH_REQUESTED: 'Event refresh requested - reloading SrEvents',
  },
  SR_EVENT_TABLE: {
    // Table configuration
    CURRENT_PAGE_REPORT_TEMPLATE: 'Zobrazeno {first} až {last} z {totalRecords} záznamů',
    GLOBAL_FILTER_PLACEHOLDER: 'Hledat ve všech sloupcích...',

    // Column headers
    TITLE: 'Název',
    CONTACT_TYPE: 'Typ kontaktu',
    PLANNED_FROM: 'Plánováno od',
    PLANNED_TO: 'Plánováno do',
    REALIZED_FROM: 'Realizováno od',
    REALIZED_TO: 'Realizováno do',
    DESCRIPTION: 'Popis',
    STATUS: 'Stav',
    ACTIONS: 'Akce',

    // Filter placeholders
    SEARCH_TITLE: 'Hledat název...',
    SELECT_CONTACT_TYPE: 'Vybrat typ...',
    FROM_DATE: 'Od data...',
    TO_DATE: 'Do data...',
    SEARCH_DESCRIPTION: 'Hledat v popisu...',
    SELECT_STATUS: 'Vybrat stav...',

    // Action tooltips
    EDIT_EVENT_TOOLTIP: 'Upravit událost',
  },
  TAG_EDITOR: {
    ENTER_NOTES_PLACEHOLDER: 'Zadejte zápis...',
    INSERT_TAG: 'Vložit značku',
    INSERT_TAG_TOOLTIP: 'Vložit značku k označenému textu',
    DEBUG_HTML: 'Debug HTML',
    DEBUG_HTML_TOOLTIP: 'Zkopírovat HTML obsah editoru do schránky',
    SHOW_HTML: 'HTML',
    SHOW_HTML_TOOLTIP: 'Zobrazit HTML obsah pro debugging',
    TEST_CONTENT: 'Test',
    TEST_CONTENT_TOOLTIP: 'Vygenerovat testovací obsah',
    INSERTED_TAGS: 'Vložené značky',
    REMOVE_TAG: 'Odstranit značku',
    SEARCH_TAGS: 'Hledat značky...',
    NO_RECORDS_TITLE: 'Žádné záznamy',
    NO_RECORDS_MESSAGE: 'Klient není zařazen v žádném programu. Zařadit jej můžete',
    NO_RECORDS_LINK: 'zde',
    GO_TO_IP_JOURNAL: 'Přejít na IP deník',
    VALIDATION: {
      TAG_REQUIRED: 'Je nutné označit text alespoň jednou značkou',
    },
    TOOLBAR: {
      BOLD: 'Tučné',
      ITALIC: 'Kurzíva',
      UNDERLINE: 'Podtržení',
      ORDERED_LIST: 'Číslovaný seznam',
      BULLET_LIST: 'Odrážkový seznam',
      INSERT_LINK: 'Vložit odkaz',
      REMOVE_FORMATTING: 'Odstranit formátování',
    },
    PLACEHOLDER: 'Začněte psát...',
    NO_TEXT_SELECTED: 'Nebyl označen žádný text.',
    URL_PROMPT: 'Zadejte URL:',
    REFRESH_TAGS: 'Aktualizovat seznam značek',
  },
  TABLE: {
    globalFilterPlaceholder: 'Hledat...',
    EMPTY_DATA_MESSAGE: 'Žádné záznamy nebyly nalezeny',
    EMPTY_CONTENT_TEMPLATE: 'Žádná šablona sbalitelného obsahu nebyla nalezena',
    SUMMARY_TOTAL: 'Počet záznamů: ',
    REMOVE_TABLE_FILTERS: 'Smazat tabulkové filtry',
    currentPageReportTemplate: 'Zobrazeno {first} až {last} z {totalRecords} záznamů',
  },
  CLIENT_IP_LIST: {
    TREE_NAME: 'Stromová struktura IP',
    TREE: {
      COPY_STRUCTURE_TO_OTHER_CLIENTS: 'Kopírovat k jinému klientovi',
      ADD: {
        PROGRAM_ENROLLMENT_ADD_TOOLTIP: 'Přidat zařazení do programu',
        INDIVIDUAL_PLAN_ADD_TOOLTIP: 'Přidat individuální plán',
        GOAL_ADD_TOOLTIP: 'Přidat cíl',
        STEP_ADD_TOOLTIP: 'Přidat krok',
      },
      COMPLETED: {
        PROGRAM_ARCHIVED_TOOLTIP: 'Program byl archivován',
        PROGRAM_ENROLLMENT_TERMINATED_TOOLTIP: 'Zařazení do programu bylo ukončeno',
        INDIVIDUAL_PLAN_CLOSED_TOOLTIP: 'Individuální plán byl archivován',
        GOAL_COMPLETED_TOOLTIP: 'Cíl byl splněn',
        STEP_COMPLETED_TOOLTIP: 'Krok byl splněn',
      },
    },
    SETTING_TREE: {
      EXPAND_ALL_TOOLTIP: 'Rozbalit vše',
      COLLAPSE_ALL_TOOLTIP: 'Zabalit vše',
      SETTING_ICON_TOOLTIP: 'Nastavení',
      CANCEL_SETTINGS_TOOLTIP: 'Zrušit úpravy výběru',
    },
    SETTING_MODAL: {
      TITLE: 'Upravit nastavení',
      SHOW_CLOSED_IP: 'I archivované IP',
      SHOW_ARCHIVED_PROGRAMS: 'I archivované programy',
      SHOW_ARCHIVED_PROGRAMS_ENROLLMENTS: 'I ukončená zařazení do programů',
      SHOW_COMPLETED_GOALS: 'I splněné cíle',
      SHOW_COMPLETED_STEPS: 'I splněné kroky',
      DUE_DATE: 'Období splatnosti maximálně do',
      APPLY_SETTINGS: 'Aplikovat',
      RESET_SETTINGS: 'Resetovat',
    },
    JOURNAL_ENTRY_MODAL: {
      TITLE: { ADD: 'Přidat deníkový záznam nevázaný na událost', EDIT: 'Upravit deníkový záznam' },
    },
    JOURNAL_ENTRY_EVENT_MODAL: {
      ERROR_OPEN:
        'Nepovedlo se otevřit okno s informacemi události. Otevírá se okno s přímou úpravou deníkového záznamu.',
    },
    JOURNAL_ENTRIES_TABLE: {
      HEADERS: {
        TAG: 'Značky',
        TITLE: 'Název',
        AUTHOR_FULL_NAME: 'Autor',
        IMPORTANCE: 'Důležitost',
        DATE: 'Datum',
        JOURNAL_ENTRY_TYPE: 'Typ záznamu',
        EVENT_DURATION: 'Délka [h:m]',
        EVENT_WORKERS_FULL_NAMES: 'Pracovníci',
        ACTIONS: {
          EDIT: 'Editovat deníkový záznam',
        },
      },
      JOURNAL_ENTRY_TYPES: {
        EVENT_ENTRY: 'Zápis',
        JOURNAL_ENTRY: 'Deník',
      },
      COLLAPSIBLE: {
        ERROR_LOAD: 'Nepovedl se načíst text deníkového záznamu',
        ERROR_SUBMIT: 'Nepovedlo se uložit upravený text deníku.',
        SUCCESS_SUBMIT: 'Formulář úspěšně odeslán.',
      },
      TOOLBAR: {
        ADD_NEW_JOURNAL_ENTRY: 'Přidat deníkový záznam',
      },
    },
  },
  JOURNAL_ENTRY_FORM: {
    TITLE: { ADD: 'Přidat deníkový záznam nevázaný na událost', EDIT: 'Upravit deníkový záznam' },
    LABELS: {
      DATE_TIME: 'Datum a čas',
      IMPORTANCE: 'Důležitost',
      TITLE: 'Nadpis',
      CONTENT: 'Text',
    },
    SUBMIT_BTN: {
      EDIT: 'Uložit',
      ADD: 'Uložit',
    },
    ERROR_SUBMIT: 'Nepovedlo se uložit deníkový záznam',
    SUCCESS_SUBMIT: 'Deníkový záznam byl úspěšně uložen',
  },
  CLIENT_IP_COLLAPSIBLE_CONTENT: {
    STEP: {
      TITLE: 'Krok',
    },
    GOAL: {
      TITLE: 'Cíl',
    },
    INDIVIDUAL_PLAN: {
      TITLE: 'Individuální plán',
    },
    PROGRAM_ENROLLMENT: {
      TITLE: 'Zařazení do programu',
    },
  },
  STEP_EDITOR: {
    TITLE_CREATE: 'Přidat krok',
    TITLE_EDIT: 'Upravit krok',
    PARENT_PROGRAM_LABEL: 'Spadá do programu:',
    FIELDS: {
      NAME: 'Jméno',
      CRITERION: 'Kritérium',
      DUE_DATE: 'Datum do kdy má být splněno',
      DESCRIPTION: 'Popis',
    },
    PLACEHOLDER: {
      NAME: 'Zadejte název kroku',
      CRITERION: 'Zadejte kritérium splnění',
      DUE_DATE: 'Vyberte datum',
      DESCRIPTION: 'Zapište popis',
    },
    ACTIONS: {
      SAVE: 'Uložit',
      CANCEL: 'Zrušit',
    },
    VALIDATION: {
      REQUIRED: 'Pole je povinné.',
      DATE_INVALID: 'Neplatné datum.',
    },
    TOAST: {
      SAVE_SUCCESS: 'Krok úspěšně uložen',
      SAVE_ERROR: 'Chyba při ukládání kroku',
    },
  },
  GOAL_EDITOR: {
    TITLE_CREATE: 'Přidat cíl',
    TITLE_EDIT: 'Upravit cíl',
    PARENT_PROGRAM_LABEL: 'Spadá do programu:',
    FIELDS: {
      NAME: 'Jméno',
      CRITERION: 'Kritérium',
      DUE_DATE: 'Datum do kdy má být splněno',
      DESCRIPTION: 'Popis',
    },
    PLACEHOLDER: {
      NAME: 'Zadejte název cíle',
      CRITERION: 'Zadejte kritérium splnění',
      DUE_DATE: 'Vyberte datum',
      DESCRIPTION: 'Zapište popis',
    },
    ACTIONS: {
      SAVE: 'Uložit',
      CANCEL: 'Zrušit',
    },
    VALIDATION: {
      REQUIRED: 'Pole je povinné.',
      DATE_INVALID: 'Neplatné datum.',
    },
    TOAST: {
      SAVE_SUCCESS: 'Cíl úspěšně uložen',
      SAVE_ERROR: 'Chyba při ukládání cíle',
    },
  },
  INDIVIDUAL_PLAN_EDITOR: {
    TITLE_CREATE: 'Přidat individuální plán',
    TITLE_EDIT: 'Upravit individuální plán',
    PARENT_PROGRAM_LABEL: 'Spadá do programu:',
    FIELDS: {
      NAME: 'Jméno',
      CRITERION: 'Kritérium',
      DUE_DATE: 'Datum do kdy má být splněno',
      DESCRIPTION: 'Popis',
      CONTRACTED_GOAL: 'Smluvený cíl',
    },
    PLACEHOLDER: {
      NAME: 'Zadejte název individuálního plánu',
      CRITERION: 'Zadejte kritérium splnění',
      DUE_DATE: 'Vyberte datum',
      DESCRIPTION: 'Zapište popis',
      CONTRACTED_GOAL: 'Zadejte cíl',
    },
    ACTIONS: {
      SAVE: 'Uložit',
      CANCEL: 'Zrušit',
    },
    VALIDATION: {
      REQUIRED: 'Pole je povinné.',
      DATE_INVALID: 'Neplatné datum.',
    },
    TOAST: {
      SAVE_SUCCESS: 'Individuální plán úspěšně uložen',
      SAVE_ERROR: 'Chyba při ukládání individuálního plánu',
    },
  },
  PROGRAM_ENROLLMENT_EDITOR: {
    TITLE_CREATE: 'Přidat zařazení do programu',
    TITLE_EDIT: 'Upravit zařazení do programu',
    PARENT_PROGRAM_LABEL: 'Spadá do programu:',
    FIELDS: {
      PROGRAM: 'Program',
      WAITING_LIST_START_DATE: 'Datum zahájení čekací listiny',
      IS_TERMINATED: 'Ukončeno',
      TERMINATION_REASON: 'Důvod ukončení',
      CONTRACTED_GOAL: 'Smluvený cíl',
    },
    PLACEHOLDER: {
      WAITING_LIST_START_DATE: 'Vyberte datum',
      TERMINATION_REASON: 'Zapište důvod ukončení',
      CONTRACTED_GOAL: 'Zapište smluvený cíl',
    },
    ACTIONS: {
      SAVE: 'Uložit',
      CANCEL: 'Zrušit',
    },
    VALIDATION: {
      REQUIRED: 'Pole je povinné.',
      DATE_INVALID: 'Neplatné datum.',
      WAITING_LIST_START_DATE_REQUIRED: 'Datum zahájení čekací listiny je povinné.',
    },
    EMPTY_MESSAGES: {
      NO_PROGRAMS_AVAILABLE: 'Žádný program k zařazení',
    },
    TOAST: {
      SAVE_SUCCESS: 'Zařazení do programu úspěšně uloženo',
      SAVE_ERROR: 'Chyba při ukládání zařazení do programu',
    },
  },
  CLIENT_IP_CARD: {
    NO_END_DATE: 'Neurčeno',
    ITEM_TYPE: {
      PROGRAM_ENROLLMENT: 'Zařazení do programu',
      INDIVIDUAL_PLAN: 'Individuální plán',
      GOAL: 'Cíl',
      STEP: 'Krok',
    },
    PROGRAM_ENROLLMENT: {
      DO_EDIT: 'Upravit',
      DO_START: 'Znovu zahájit zařazení',
      DO_TERMINATE: 'Ukončit zařazení',
      DO_DELETE: 'Smazat',
      PROGRAM_DESCRIPTION: 'Popis programu',
      PROGRAM_ARCHIVED_AT: 'Datum archivace programu',
      WAITING_LIST_START_DATE: 'Datum zapsání na čekací listinu',
      IS_TERMINATED: 'Je ukončen',
      TERMINATION_REASON: 'Důvod ukončení',
      DURATIONS: 'Doba trvání zařazení do programu',
      WILL_TERMINATE_ALERT: 'Zařazení do programu {{program}} pro klienta {{client}} bude ukončeno.',
      WILL_START_ALERT: 'Zařazení do programu {{program}} pro klienta {{client}} bude znovu zahájeno.',
      WILL_DELETE_ALERT: 'Zápis programu {{program}} pro klienta {{client}} bude trvale smazán.',
    },
    INDIVIDUAL_PLAN: {
      DO_EDIT: 'Upravit',
      DO_OPEN: 'Obnovit z archivu',
      DO_CLOSE: 'Archivovat',
      DO_DELETE: 'Smazat',
      DESCRIPTION: 'Popis',
      CONTRACTED_GOAL: 'Smluvený cíl',
      DUE_DATE: 'Termín revize',
      CLOSED_AT: 'Datum archivace',
      WILL_CLOSE_ALERT: 'Individuální plán {{plan}} programu {{program}} klienta {{client}} bude archivován.',
      WILL_OPEN_ALERT: 'Individuální plán {{plan}} programu {{program}} klienta {{client}} bude obnoven z archivu.',
      WILL_DELETE_ALERT: 'Individuální plán {{plan}} programu {{program}} klienta {{client}} bude trvale smazán.',
    },
    GOAL: {
      DO_EDIT: 'Upravit',
      DO_COMPLETE: 'Označit jako splněný',
      DO_UNFULFILL: 'Označit jako nesplěný',
      DO_DELETE: 'Smazat',
      DESCRIPTION: 'Popis',
      CRITERION: 'Kritérium',
      DUE_DATE: 'Má být splněno do',
      COMPLETED_AT: 'Splněno',
      WILL_COMPLETE_ALERT: 'Cíl {{goal}} individuálního plánu {{plan}} klienta {{client}} bude označen jako splněný.',
      WILL_UNFULFILL_ALERT:
        'Cíl {{goal}} individuálního plánu {{plan}} klienta {{client}} bude označen jako nesplněný.',
      WILL_DELETE_ALERT: 'Cíl {{goal}} individuálního plánu {{plan}} klienta {{client}} bude trvale smazán.',
    },
    STEP: {
      DO_EDIT: 'Upravit',
      DO_COMPLETE: 'Označit jako splněný',
      DO_UNFULFILL: 'Označit jako nesplěný',
      DO_DELETE: 'Smazat',
      DESCRIPTION: 'Popis',
      CRITERION: 'Kritérium',
      DUE_DATE: 'Má být splněno do',
      COMPLETED_AT: 'Splněno',
      WILL_COMPLETE_ALERT: 'Krok {{step}} cíle {{goal}} klienta {{client}} bude označen jako splněný.',
      WILL_UNFULFILL_ALERT: 'Krok {{step}} cíle {{goal}} klienta {{client}} bude označen jako nesplněný.',
      WILL_DELETE_ALERT: 'Krok {{step}} cíle {{goal}} klienta {{client}} bude trvale smazán.',
    },
  },
  STATISTICS: {
    TITLE: 'Statistiky',
    PERIOD_SELECTION: 'Výběr období',
    DATE_FROM: 'Od',
    DATE_TO: 'Do',
    YEAR: 'Rok',
    MONTH: 'Měsíc',
    REFRESH: 'Aktualizovat',
    CLIENT_STATISTICS: 'Statistiky klientů',
    EMPLOYEE_STATISTICS: 'Statistiky pracovníků',
    INVALID_DATE_RANGE: 'Datum od nemůže být větší než datum do',
    UNIQUE_CLIENTS: 'unikátních klientů s alespoň jedním výkonem ve zvoleném období',
    ANONYMOUS_CLIENTS_COUNT: 'anonymů ve zvoleném období',
    UNIQUE_EMPLOYEES: 'unikátních zaměstnanců s alespoň jedním výkonem ve zvoleném roce',
    TOTAL_HOURS_CLIENTS: 'celková suma vykázaných hodin za všechny klienty',
    TOTAL_HOURS_EMPLOYEES: 'celková suma odpracovaných hodin všech zaměstnanců',
    PP1_STATISTICS: 'Statistiky PP1',
    PP2_STATISTICS: 'Statistiky PP2',
    PP1_TOTAL: 'PP1 celkem',
    PP2_TOTAL: 'PP2 celkem',
    WORK_TYPE_BREAKDOWN: 'Rozdělení podle typu práce',
    PP1_INDIVIDUAL: 'PP1 (Individuální)',
    PP2_GROUP: 'PP2 (Skupinové)',
    CLIENT_DETAILS: 'Detailní přehled po klientech',
    EMPLOYEE_DETAILS: 'Detailní přehled po zaměstnancích',
    SHOW_ALL: 'Zobrazit všechny',
    CLIENT: 'Klient',
    HOURS: 'Hodiny (hh:mm)',
    PERFORMANCES: 'Počet výkonů',
    EMPLOYEE: 'Zaměstnanec',
    PP1_HOURS: 'PP1 (h)',
    PP2_HOURS: 'PP2 (h)',
    TOTAL: 'Celkem (h)',
    ACTIONS: 'Akce',
    EXPORT_XLS: 'Exportovat do XLS',
    REFRESH_DATA: 'Obnovit data',
    DATA_VALID_TO: 'data validní k',
    SEARCH_CLIENT: 'Hledat klienta...',
    SEARCH_EMPLOYEE: 'Hledat zaměstnance...',
    SEARCH_CLIENT_OR_EMPLOYEE: 'Hledat v klientských/zaměstnaneckých statistikách...',
    TABLE_HEADERS: {
      CLIENT: 'Klient',
      EMPLOYEE: 'Zaměstnanec',
      HOURS: 'Hodiny (hh:mm)',
      PERFORMANCES: 'Počet výkonů',
      PP1_HOURS: 'PP1 (h)',
      PP2_HOURS: 'PP2 (h)',
      TOTAL: 'Celkem (h)',
      PP1_INDIVIDUAL_HOURS: 'PP1 individuální (h)',
      PP1_GROUP_HOURS: 'PP1 skupinová (h)',
      PP1_SUM_HOURS: 'PP1 suma (h)',
      PP2_INDIVIDUAL_HOURS: 'PP2 individuální (h)',
      PP2_GROUP_HOURS: 'PP2 skupinová (h)',
      PP2_SUM_HOURS: 'PP2 suma (h)',
      TOTAL_PP1_PP2_HOURS: 'Suma PP1 + PP2 (h)',
    },
    EXPORT_SHEET_NAME_INFO: 'Informace',
    EXPORT_SHEET_NAME_EMPLOYEE: 'Statistiky zaměstnanců',
    EXPORT_SHEET_NAME_CLIENT: 'Statistiky klientů',
    EXPORT_FILE_NAME_PREFIX: 'Statistiky',
    EXPORT_LABEL_PERIOD: 'Období exportu',
    EXPORT_LABEL_FROM: 'Od',
    EXPORT_LABEL_TO: 'Do',
    EXPORT_LABEL_CREATED: 'Vytvořeno',
    EXPORT_ROW_LABEL_SUM: 'Suma',
  },
  PROGRAMS_LIST: {
    TITLE: 'Programy',
    EDIT_TOOLTIP: 'Upravit program',
    LOADING: 'Načítání...',
    TABLE: {
      globalFilterPlaceholder: 'Hledat v programech...',
      HEADERS: {
        title: 'Název',
        description: 'Popis',
        socialService: 'Sociální služba',
        archivedAt: 'Datum archivace',
        actions: 'Akce',
      },
    },
  },
  PROGRAM_EDITOR: {
    BASIC: 'Základní',
    TITLE_CREATE: 'Přidat program',
    TITLE_EDIT: 'Upravit program',
    DELETE_CONFIRMATION_HEADER: 'Smazat program',
    DELETE_CONFIRMATION_MESSAGE: 'Opravdu chcete smazat tento program? Tato akce je nevratná.',
    FIELDS: {
      ARCHIVED_AT: 'Datum archivace',
      DESCRIPTION: 'Popis',
      SOCIAL_SERVICE: 'Sociální služba',
      NAME: 'Název',
    },
    PLACEHOLDER: {
      NAME: 'Zadejte název programu',
      DESCRIPTION: 'Zapište popis',
      SOCIAL_SERVICE: 'Vyberte sociální službu',
    },
    ACTIONS: {
      SAVE: 'Uložit',
      DELETE: 'Smazat',
      ARCHIVE: 'Archivovat',
      UNARCHIVE: 'Aktivovat',
    },
    VALIDATION: {
      REQUIRED: 'Pole je povinné',
    },
    TOAST: {
      SAVE_SUCCESS: 'Program úspěšně uložen',
      SAVE_ERROR: 'Chyba při ukládání programu',
    },
  },
  PROGRAMS_LIST_TOOLBAR: {
    NEW_PROGRAM_TOOLTIP: 'Přidat nový program',
    NEW_PROGRAM: 'Nový program',
  },
  EVENTS_LIST: {
    TITLE: 'Události',
    EDIT_TOOLTIP: 'Upravit událost',
    LOADING: 'Načítání...',
    TABLE: {
      globalFilterPlaceholder: 'Hledat v událostech...',
      HEADERS: {
        eventTypeName: 'Typ události',
        note: 'Poznámka',
        status: 'Stav',
        plannedFrom: 'Plánováno od',
        plannedTo: 'Plánováno do',
        durationPlanned: 'Délka plánovaná',
        realizedFrom: 'Realizováno od',
        realizedTo: 'Realizováno do',
        durationRealized: 'Délka Realizováno',
        workers: 'Pracovníci',
        clients: 'Klienti',
        actions: 'Akce',
      },
    },
  },
  EVENTS_LIST_TOOLBAR: {
    NEW_EVENT_TOOLTIP: 'Přidat novou událost',
    NEW_EVENT: 'Nová událost',
    SELECT_EVENT_TYPE: 'Vyberte typ události',
    EXCEL_EXPORT: 'Excel export',
    LEAVE_EVENT: 'Nepřítomnost',
    LEAVE_EVENT_DESCRIPTION: 'Vytvořit novou nepřítomnost',
  },
  CONFIG: {
    ORGANIZATION_NAME: 'Název',
    ORGANIZATION_ADDRESS: 'Adresa sídla',
    ORGANIZATION_PHONE: 'Telefon',
    ORGANIZATION_ID_NUMBER: 'IČO',
    ORGANIZATION_BANK_ACCOUNT_NUMBER: 'Číslo účtu',
    ORGANIZATION_BANK_NAME: 'Název banky',
    ORGANIZATION_BANK_ADDRESS: 'Adresa banky',
  },

  IP_JOURNAL_COPY_EDITOR: {
    TITLE: 'Kopírovat IP k jinému klientovi',
    STRUCTURE_CHOOSE_TITLE: 'IP',
    COPY_BUTTON: 'Kopírovat',
    TOAST: {
      SAVE_SUCCESS: 'IP úspěšně zkopírován',
      SAVE_ERROR: 'Chyba při kopírování IP',
    },
    VALIDATION: {
      CLIENT_REQUIRED: 'Klient je povinný',
      IP_ENTRIES_REQUIRED: 'Vyberte alespoň jednu položku',
    },
  },
  CALENDAR: {
    BUTTON_HINTS: {
      PREV: 'Předchozí týden',
      NEXT: 'Další týden',
      TODAY: 'Tento týden',
      DAY_VIEW: 'Zobrazení dne',
      WEEK_VIEW: 'Zobrazení týdne',
    },
  },
  USER_LIST: {
    FIRST_NAME: 'Jméno',
    LAST_NAME: 'Příjmení',
    LOGIN: 'Login',
    ROLES: 'Role',
    WORKGROUP: 'Pracovní skupina',
    WORKGROUP_ABBR: 'PS',
    SOCIAL_SERVICE: 'Sociální služba',
    LOCATION: 'Lokace',
    ACTIONS: 'Akce',
    DELETE_CONFIRMATION_HEADER: 'Smazat uživatele',
    DELETE_CONFIRMATION_MESSAGE: 'Opravdu chcete smazat tohoto uživatele?',
  },
  EDIT_USER: {
    EDIT_USER: 'Upravit uživatele',
    CREATE_USER: 'Vytvořit uživatele',
    BASIC_DETAILS: 'Základní údaje',
    PERMISSIONS: 'Oprávnění',
    LOGIN_DETAILS: 'Přihlašovací údaje',
    OTHER: 'Ostatní',
    FIRST_NAME: 'Jméno',
    LAST_NAME: 'Příjmení',
    GENDER: 'Pohlaví',
    BIRTH_DATE: 'Datum narození',
    WORKGROUP: 'Pracovní skupina',
    KEY_COORDINATOR: 'Klíčový koordinátor',
    EMAIL: 'Email',
    PASSWORD: 'Heslo',
    ONLY_IF_CHANGING_PASSWORD: 'pouze pokud jej měníte',
    ENTER_VALID_FIRST_NAME: 'Zadejte jméno',
    ENTER_VALID_LAST_NAME: 'Zadejte příjmení',
    ENTER_VALID_EMAIL: 'Zadejte platný email',
    EMAIL_ALREADY_IN_USE: 'Tento email už používá jiný uživatel',
    ENTER_VALID_PASSWORD: 'Zadejte platné heslo (alespoň {{minLength}} znaků)',
    ENTER_VALID_BIRTH_DATE: 'Zadejte datum narození',
    BIRTH_DATE_MUST_BE_IN_PAST: 'Datum narození musí být v minulosti',
    SELECT_GENDER: 'Vyberte pohlaví',
    SELECT_WORKGROUP: 'Vyberte pracovní skupinu',
    SELECT_KEY_COORDINATOR: 'Vyberte klíčového koordinátora',
    SOME_PERMISSION_REQUIRED: 'Uživatel musí mít alespoň jedno oprávnění',
    SAVE_SUCCESSFUL: 'Uživatel uložen',
    SAVE_FAILED: 'Chyba při ukládání uživatele',
  },
  ATTENDANCE_REPORT: {
    PAGE_TITLE: 'Výkaz práce',
    TOAST_EXPORT_FAILED: 'Export se nezdařil. Zkuste to prosím znovu.',
    LOAD_ERROR: 'Nepodařilo se načíst výkaz docházky.',
    NO_CONTRACTS: 'Pracovník nemá v zadaném období žádnou pracovní smlouvu.',
    WORK_POSITION: 'Pracovní pozice',
    DEFAULT_WORKER_NAME: 'Pracovník',
    UNKNOWN_WORKER: 'Neznámý pracovník',
    TOOLTIP_SHOW_TOOLBAR: 'Zobrazit panel nástrojů',
    TOOLTIP_HIDE_TOOLBAR: 'Skrýt panel nástrojů',
    ARIA_PREV_MONTH: 'Předchozí měsíc',
    ARIA_NEXT_MONTH: 'Další měsíc',
    REAL_ATTENDANCE_TITLE: 'Reálná docházka',
    CONTRACT_UVAZEK_FOND: 'Úvazek: {{uvazek}} | Měsíční fond pracovní doby: {{fond}}',
    PLACEHOLDER_TIME: 'HH:MM',
    PLACEHOLDER_HOURS: '00:00',
    VALIDATION_TIME_FROM_BEFORE_TO: 'Čas od musí být menší než čas do',
    CONTRACT_NAME: 'Smlouva {{index}}',
    SHEET_NAME_FALLBACK: 'Smlouva_{{index}}',
    EXPORT_EVIDENCE_LABEL: 'Export Evidence pracovní doby',
    EXPORT_EVIDENCE_DESC: 'Exportuje evidenci docházky',
    EXPORT_COMPLETE_LABEL: 'Export Komplet',
    EXPORT_COMPLETE_DESC: 'Exportuje evidenci docházky i reálnou docházku',
    FILE_NAME_EVIDENCE_PREFIX: 'Evidence-pracovni-doby',
    FILE_NAME_COMPLETE_PREFIX: 'Export-komplet',
    EXPORT: {
      AGG_WORKING_TITLE: 'Agregace – pracovní doba',
      AGG_ABSENCE_TITLE: 'Agregace – absence',
      SHEET_REAL_ATTENDANCE: 'Reálná docházka',
    },
    TOTALS: 'Celkem:',
    AGG_WORKING: {
      MONTHLY_FUND: 'Měsíční pracovní fond',
      WORKED_HOURS: 'Odpr. hodiny',
      STANDBY_FULFILLED: 'Odpr. pohotovost',
      OVERTIME: 'Přesčas (v měsíci)',
      NIGHT: 'Práce noc',
      WEEKEND: 'Práce víkend',
      HOLIDAY: 'Práce svátek',
      STANDBY: 'Pohotovost',
    },
    AGG_REAL: {
      OVERTIME_UNDERTIME: 'Přesčas / nedočas',
      OVERTIME_UNDERTIME_TOOLTIP: 'Součet sloupce vyrovnání',
      ABSENCE_TOTAL: 'Absence celkem',
    },
    ABSENCE: {
      VACATION: 'Dovolená',
      SICKNESS: 'Dočasná pracovní neschopnost',
      SICK_DAY: 'Sick day',
      PAID_LEAVE: 'Placené volno',
      NURSING: 'Ošetřování člena rodiny',
      UNEXCUSED: 'Neomluvená absence',
      UNPAID_LEAVE: 'Neplacené volno',
      OTHER: 'Jiný důvod',
    },
    ABSENCE_AGG: {
      COL_NAME: 'Název absence',
      COL_HOURS: 'h:mm',
      COL_DATES: 'Datum',
      TOTAL: 'Celkem',
    },
    COLUMNS: {
      DATUM: 'Datum',
      DEN: 'Den',
      CAS_OD: 'Čas od',
      CAS_DO: 'Čas do',
      PRESTAVKA: 'Přest. [h]',
      ODPRAC_HODINY: 'Odprac. [h]',
      NOC: 'Noc [h]',
      VIKEND: 'Víkend [h]',
      SVATEK: 'Svátek [h]',
      PRESCAS: 'Přesčas [h]',
      POHOTOVOST: 'Pohot. [h]',
      ODPR_POH: 'Odprac. pohot. [h]',
      POZNAMKA: 'Poznámka',
      ABSENCE: 'Absence',
      ABS_HODINY: 'Abs. [h]',
      PP1: 'PP1',
      PP2: 'PP2',
      NP: 'NP',
      SUMA: 'SUMA',
      DOSTUPNOST_HODINY: 'Dostupnost hodiny',
      VYROVNANI: 'Vyrovnání',
      TYP_PRACE: 'Typ práce',
      PRIPLATKY_HODINY: 'příplatky/hodiny',
    },
  },
} as const

// Export the translations for the loader
export const cs = TRANSLATIONS
